module.exports = __webpack_public_path__ + "static/media/support.f48e0742.svg";